import { render, staticRenderFns } from "./MailTrash.vue?vue&type=template&id=7533f614"
import script from "./MailTrash.vue?vue&type=script&lang=js"
export * from "./MailTrash.vue?vue&type=script&lang=js"
import style0 from "./MailTrash.vue?vue&type=style&index=0&id=7533f614&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports